import { ReactNode } from 'react';

import { cn } from 'components/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

interface HeaderPanelControlProps {
  isOpen: boolean;
  onClick: () => void;
  tooltip: string;
  icon: ReactNode;
  dataTestId?: string;
}

export const HeaderPanelControl: React.FC<HeaderPanelControlProps> = ({
  isOpen,
  onClick,
  tooltip,
  icon,
  dataTestId
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          data-testid={dataTestId}
          className={cn(
            'w-9 h-9 flex justify-center items-center cursor-pointer hover:bg-neutral-100 rounded-md',
            isOpen ? 'text-indigo-500 bg-neutral-100' : 'text-base-sidebarRing'
          )}
          onClick={onClick}
        >
          {icon}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
          {tooltip}
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
